import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import RestTypeItemView from './RestTypeItem';

@propsDecorator({
    itemView: RestTypeItemView,
    bindings: {
        '#restTypesTemplate': 'collection: $collection',
    },
})
export default class RestTypesView extends Backbone.Epoxy.View {
    initialize(options) {
        this.collection = options.collection;
        this.model = options.parentModel;
    }
}
